import type { AllRouteEndpoints } from "../routeTypes";

export const engagementAppGroupIdBannerTemplates = "/engagement/:app_group_id/banner_templates";

export const engagementAppGroupIdBannerTemplatesCacheKeys: AllRouteEndpoints[] = [
  "/engagement/:app_group_id/banner_templates",
  "/engagement/:app_group_id/banner_templates/:id",
];
